<template>
    <div class="policy">      
更新日期：2022年12月15日<br />
<br />
生效日期：2022年12月15日<br />
<br />
为更充分保障您的权利，若您有任何问题或建议，请根据本隐私政策第11条所述方式联系我们。<br />
<br />
概要<br />
<br />
欢迎使用深圳魔力数娱网络科技有限公司（以下简称“我们”）提供的《我的勇者》游戏产品及相关服务。我们非常重视保护用户的隐私信息，我们收集信息是为了向所有用户提供更好地服务。我们在收集用户信息过程中，严格遵守法律法规，秉承正当、合法、必要的原则，最低限度使用用户的用户信息，以便为您提供更加安全、可靠的服务。<br />
<br />
本隐私政策中《我的勇者》游戏及其服务的提供方深圳魔力数娱网络科技有限公司，注册地为深圳市前海深港合作区前湾一路1号A栋201室(入驻深圳市前海商务秘书有限公司)，个人信息保护工作机构为公司产品运营中心。<br />
<br />
以下摘要能帮助您更直观、简洁地概览隐私政策的内容。<br />
<br />
1.我们收集的信息<br />
<br />
业务场景： 游戏账号注册及实名认证<br />
收集方式： 您主动提供的信息<br />
信息类型： 昵称、头像、手机号码、身份证号码、电子邮件<br />
<br />
业务场景： 产品安全及优化体验需要<br />
收集方式： 我们收集的信息<br />
信息类型：登录 IP地址；操作日志、服务日志信息等日志信息；移动设备型号、软件版本信息、操作系统及版本、网页浏览器类型、Mac地址、移动网络信息、您的设备ID、设备型号、运营商、硬件序列号、传感器、应用安装列表、android_id/IMEI/IDFA/OPENUDID/GUID、SIM卡IMSI信息；充值消费信息；电话；位置信息；广告追踪。<br />
<br />
2.我们如何保护信息<br />
<br />
我们为您的信息提供相应的安全保障，以防止信息的丢失、不当使用、未经授权访问或披露，包括：<br />
<br />
•      我们将在合理的安全水平内使用各种安全保护措施以保障信息的安全。<br />
<br />
•      我们通过不断提升的技术手段加强安装在你设备端的软件的安全能力。<br />
<br />
•      我们建立专门的管理制度、操作规程和组织以保障信息的安全。<br />
<br />
3.我们服务中涉及的第三方数据处理<br />
<br />
我们与第三方合作过程中，将遵守法律规定，按照最小必要原则，安全审慎地处理相关数据。我们将按照法律法规的规定，与第三方共同努力保障数据安全。<br />
<br />
4. 您如何管理自己的信息<br />
<br />
您在使用我们服务的过程中， 可以通过查询、更正、删除等方式来管理你的个人信息。具体方式包括：<br />
<br />
查询您的个人信息（仅官方渠道）<br />
<br />
操作路径如下：游戏主界面→设置→个人信息收集，即可查询您的个人信息。<br />
<br />
更正您的个人信息<br />
<br />
您可通过《隐私政策》列明的联系方式与我们取得联系，要求我们予以更正。也可选择自行更正，操作路径如下：用户中心→绑定账号→更换手机，输入新手机号码验证成功后即可更新您的个人信息。<br />
<br />
删除您的个人信息<br />
<br />
您可通过本《隐私政策》列明的联系方式与我们联系，也可以通过注销账户删除您的个人信息：<br />
<br />
改变您授权同意的范围<br />
<br />
如您在点击同意我们按照本《隐私政策》收集您的个人信息后想撤回同意授权的，操作路径如下：用户中心→隐私政策→撤销同意，即可撤回同意收集您的个人信息。<br />
<br />
注销账号<br />
<br />
您可通过《隐私政策》列明的联系方式与我们取得联系，由我们的工作人员引导您进行注销操作；亦可自行进行注销操作，操作路径如下：游戏设置界面（账号设置）→用户中心→账号管理→申请注销账号→申请魔力数娱账号注销，按照界面提示进行填写操作，即可进行注销账户的操作。<br />
<br />
完整版本请查看下述《隐私政策》全文<br />
<br />
您在使用我们的产品或服务时，我们可能会收集、使用、存储、分享和管理您的相关信息。本《隐私政策》与您所使用的服务以及所享有的权利息息相关，希望您仔细阅读，了解个人信息类型与用途的对应关系等更加详尽的个人信息处理规则。特别是以粗体/粗体下划线标识的条款，您应重点阅读，在确认充分理解并同意后再开始使用。请注意我们会不时地检查并更新我们的政策，因此有关的措施会随之变化。<br />
<br />
在阅读完本《隐私政策》之后，如您对本《隐私政策》或相关事宜有任何问题，请与我们联系。您使用或继续使用我们的产品和服务，即意味着同意我们按照本《隐私政策》收集、使用、储存、分享和管理您的相关信息。<br />
<br />
本政策中涉及的专用术语和关键词有：<br />
<br />
根据国家标准《信息安全技术 个人信息安全保护规范》（GB/T35273—2020）中的规定，给出个人信息类型和个人敏感信息类型参考：<br />
<br />
a.个人信息是指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息，如姓名、出生日期、身份证件号码、个人生物识别信息、住址、通信通讯联系方式、通信记录和内容、账号密码、财产信息、交易信息等。<br />
<br />
b.个人敏感信息是指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。通常情况下，14岁以下（含）儿童的个人信息和涉及自然人隐私的信息属于个人敏感信息。<br />
<br />
<br />
1、我们可能收集的信息<br />
<br />
您在使用我们的产品或服务时，我们可能会收集、储存和使用下列与您有关的信息。如果您不提供某些相应的信息，可能无法成为我们的用户，或无法享受我们提供的某些服务或功能，或者无法达到相关服务拟达到的效果。<br />
<br />
1.1您主动提供的信息<br />
<br />
1.1.1您在使用我们的产品或服务时，需向我们提供的相关个人信息，电话号码、电子邮件、设备名称、身份信息；包括但不限于：<br />
<br />
（1）您在账户注册时填写的相关信息，昵称、头像、手机号码、身份证号码，或根据法律法规要求的实名身份信息；若您拒绝提供实名身份信息，您可能无法进入游戏，我们无法为您提供相应的服务，或在使用过程中受到相应的限制；<br />
<br />
（2）您在使用我们的服务时上传的信息；<br />
<br />
（3）您向我们的客服或参加我们的活动时提交的信息。<br />
<br />
1.1.2您通过我们的服务向其他方提供的共享信息，以及您使用我们的服务时所储存的信息。<br />
<br />
1.1.3您通过我们的服务分享的内容所包含的信息（元数据），上传的共享照片或视频所包含的日期、时间或地点。<br />
<br />
1.2我们在您使用服务时获取的信息<br />
<br />
1.2.1日志信息，指您使用我们的服务时，系统可能通过cookies或其他方式自动采集的技术信息，包括：<br />
<br />
（1）您对我们服务的详细使用情况，您的登录时间、访问的内容；<br />
<br />
（2）您通过我们的服务进行通讯的信息，通讯的账号以及通讯时间、数据和时长；<br />
<br />
（3）IP地址；<br />
<br />
（4）设备或软件信息，您的移动设备型号、软件版本信息、操作系统及版本、网页浏览器类型、Mac地址、移动网络信息、您的设备ID、设备型号、运营商、硬件序列号、传感器、应用安装列表、android_id/IMEI/IDFA/OPENUDID/GUID、SIM卡IMSI信息，我们可能会将您的唯一设备识别符或电话号码与您的账户相关联。<br />
<br />
（5）电话权限，为使您更好的使用我们的服务，需要识别您的本机识别码，以获取设备的识别码来作为您唯一的身份认证。您可以在使用我们的服务时授权我们读取您的电话权限。如果您不提供这些个人信息，您可能无法使用上述服务。<br />
<br />
1.2.2充值消费信息。当您使用我们的产品或服务的消费功能时，我们会收集和存储您的充值记录、消费记录信息，以便为您查询您账户的充值消费记录。<br />
<br />
1.2.3位置信息。经您授权同意后，我们可能会收集您的地理位置信息，用于寻找附近的游戏玩家，以便您与附近的游戏玩家匹配组队。地理位置信息属于个人敏感信息，如您不需要与其他用户互动，您可以随时撤销您的地理位置授权，其不影响您正常使用我们服务的其他功能。<br />
<br />
您开启设备定位功能，授权同意我们收集该信息并使用基于位置提供的相关服务时，我们将会：<br />
<br />
（1）您通过具有定位功能的移动设备使用我们的服务时，通过IP地址、GPS或WiFi方式收集的您的地理位置信息；<br />
<br />
（2）您或其他用户提供的包含您所处地理位置的实时信息，您提供的账户信息中包含的您所在地区信息，您或其他人上传的显示您当前或曾经所处地理位置的共享信息，您或其他人共享的照片包含的地理标记信息。<br />
<br />
1.2.4 广告追踪，为使您更好的使用我们的广告服务，您可以在使用我们的服务时授权我们获取您在其他关联App和网站上的活动记录，如果您拒绝授权将无法使用对应功能，但不影响您正常使用游戏的其他功能，您也可以随时取消相关权限授权。<br />
<br />
1.2.5 get_tasks，为使您获得更好的游戏体验，优化内存，使游戏更流畅，第三方需获取您所在设备运行的进程，以便为您提供更好的服务。<br />
<br />
1.2.6 相册读取权限，为向您提供客服系统的支持，第三方会在您点击“客服系统”内的“相册”按钮时申请存储权限，让您可以浏览本地相册并上传图片至客服系统。<br />
<br />
1.3 第三方收集或分享的您的信息<br />
<br />
为实现产品的某些功能，我们会在产品或服务中嵌入、集成第三方代码、插件、SDK，目的是为了让您得到更完整的游戏体验。<br />
<br />
对于第三方收集或分享的可能涉及的用户个人信息，我们将在附件中予以明示。其中，因需要使用Unity 提供的提报线上Bug报错服务，故需向其提供您的设备标识信息，因Unity相关主体涉及跨境，故特在此向您作出提示，我们会严格按照法律法规和相关监管部门的规定执行。<br />
<br />
2、我们可能如何使用信息<br />
<br />
2.1我们可能将在向您提供服务的过程之中所收集的信息用作下列用途：<br />
<br />
2.1.1向您提供用户服务；<br />
<br />
2.1.2在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保我们向您提供的产品和服务的安全性；<br />
<br />
2.1.3帮助我们设计新服务，改善现有服务；<br />
<br />
2.1.4软件认证或管理软件升级；<br />
<br />
2.1.5邀请您参与有关我们产品和服务的调查。<br />
<br />
2.2您的实名身份信息、地理位置信息、充值消费记录、生物识别信息等属于您的个人敏感信息。除非为了用于您个人身份验证或安全性的需求，或法律法规的强制要求，我们不会分享、使用您个人敏感信息。<br />
<br />
2.3为了让您有更好的体验、改善我们的服务或您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某一项服务所收集的信息，以汇集信息的方式，用于我们的其他服务。如果我们在相关服务中提供了相应选项，您也可以授权我们将该服务所提供和储存的信息用于我们的其他服务。<br />
<br />
3、您如何访问和管理自己的个人信息<br />
<br />
3.1我们将尽一切可能采取适当的技术手段，保证您可以访问、更新和更正自己的注册信息或使用我们的服务时提供的其他个人信息。在访问、更新、更正和删除前述信息时，我们可能会要求您进行身份验证，以保障账户安全。<br />
<br />
3.2 如您发现我们可能违反法律法规的规定，相关政策要求，或超出本《隐私政策》的范围收集、使用您的个人信息，您可以要求我们删除。如您发现我们收集、存储您的个人信息有误的，您也可以要求我们更正，同时，您还享有撤回同意收集您的个人信息的权利。<br />
<br />
3.2.1 查询您的个人信息<br />
<br />
我们将尽一切可能采取适当的技术手段，保证您可以访问自己的注册信息或使用我们的服务时提供的其他个人信息。操作路径如下：游戏主界面→设置→个人信息收集，即可查询您的个人信息。<br />
<br />
3.2.2 更正您的个人信息<br />
<br />
当您发现我们处理关于您的个人信息有错误或者您有其他修改、补充需求时，您也有权通过《隐私政策》列明的联系方式与我们取得联系，要求我们或自行予以更正。如您选择自行更正的，操作路径如下：用户中心→绑定账号→更换手机，输入新手机号码验证成功后即可更新您的个人信息。出于安全性和身份识别等方面的考虑，您需要在通过身份验证之后方可设置您的手机号码。<br />
<br />
3.2.3 删除您的个人信息<br />
<br />
在以下情形中，您可以向我们提出删除个人信息的请求，请通过本《隐私政策》列明的联系方式与我们联系，也可以通过注销账户删除您的个人信息：<br />
<br />
（1）如果我们处理个人信息的行为违反法律法规；<br />
<br />
（2）如果我们收集、使用您的个人信息，却未征得您的同意;<br />
<br />
（3）如果我们处理个人信息的行为违反了与您的约定；<br />
<br />
（4）如果您不再使用我们的产品或服务，或您注销了账号；<br />
<br />
当您或我们协助您删除相关信息后，因为适用的法律和安全技术，我们可能不会立即备份系统中删除相应的信息，但我们会采取合理措施，将相关信息安全的存储，直到备份可以清除或实现匿名。<br />
<br />
3.2.4 改变您授权同意的范围<br />
<br />
如您在点击同意我们按照本《隐私政策》收集您的个人信息后想撤回同意授权的，操作路径如下：用户中心→隐私政策→撤销同意，即可撤回同意收集您的个人信息。<br />
<br />
3.3 如您不再使用我们的产品或服务，您可通过《隐私政策》列明的联系方式与我们取得联系，由我们的工作人员引导您进行注销操作；亦可自行进行注销操作，操作路径如下：游戏设置界面（账号设置）→用户中心→账号管理→申请注销账号→申请魔力数娱账号注销，按照界面提示进行填写操作，即可进行注销账户的操作。操作前请仔细阅读下述《游戏账号注销须知》。<br />
<br />
3.3.1 注销成功后该账号将无法在我们提供的《我的勇者》游戏产品上登录且账号以及数据不可恢复；<br />
<br />
3.3.2 账号成功注销后，该账号下的所有内容、信息、记录将会被删除或匿名化处理，您也无法再检索、访问、获取、继续使用和找回，也无权要求我们找回（但法律法规另有规定或监管部门另有要求的除外）；<br />
<br />
3.3.3 您申请账号注销的行为即表明您自愿放弃该账号下的利益，在注销前，请再三确认该账号下的相关交易和提现申请已完成，避免账号注销后因无法登录而造成不必要损失；<br />
<br />
3.3.4 账号注销后，我们有权不再为您提供任何该账户有关的服务，您与我们曾签署过的相关用户协议、其他权利义务性文件等相应终止（但我们与您之间已约定继续生效的或法律法规另有规定的除外）；<br />
<br />
3.3.5 因注销账户所带来的不便或不利后果，由您自行承担，与我们无关；<br />
<br />
3.3.6 如果账号注销期间存在权属纠纷，我们有权终止注销申请；<br />
<br />
3.3.7 账号注销有7天的确认期，期间您可以再次来此界面取消注销，确认期过后将无法再取消注销；<br />
<br />
3.3.8 账号注销期间取消注销申请后，需要间隔7天后方可再次申请注销。<br />
<br />
3.3.9 尊敬的用户，请您理解并知悉，您为通过第三方应用平台下载游戏并使用第三方账号进入游戏的用户，您注册、登录第三方账号时提供给第三方的个人信息并未交于我们收集及储存，我们无权限注销您的第三方账号。如需注销第三方账号，请前往第三方应用平台寻找客服咨询，了解相应的注销流程。请您知悉并理解，第三方账号注销在第三方页面进行，我们不参与第三方账号注销流程，亦不对第三方账号注销途径的有效性、第三方账号注销成功与否作出任何承诺或保证。<br />
<br />
3.4 获取您的个人信息副本<br />
<br />
您有权获取您的个人信息副本。如您需要获取我们收集的您的个人信息副本，您可通过拨打人工客服【0755-86700315】，人工客服会对您进行个人信息校验，完成姓名、电话、身份证后六位的个人信息主体确认后，将个人信息副本通过本App在线客服提交给您。在符合相关法律规定且技术可行的前提下，我们将根据您的要求向您提供您的个人信息副本。<br />
<br />
3.5 约束信息系统自动决策<br />
<br />
    在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将提供适当的救济方式。<br />
<br />
3.6 响应您的上述请求<br />
<br />
   您的任何疑问、建议、意见及投诉，可以通过拨打客服电话【0755-86700315】联系我们的客服提交，为保障安全，我们将在必要的身份验证通过后进行处理，最长将在不超过15个工作日或法律法规规定期限内作出答复。对于您合理的请求，我们原则上不收取费用。然而，按照有关法律法规及国家标准，在以下情形中，我们可能无法响应您的请求：<br />
<br />
（1）与国家安全、国防安全直接相关的；<br />
<br />
（2）与公共安全、公共卫生、重大公共利益等有关的；<br />
<br />
（3）与犯罪侦查、起诉、审判和执行判决等有关的；<br />
<br />
（4）有充分证据表明您存在主观恶意或滥用权利的；<br />
<br />
（5）处于维护您或其他个人的生命、财产等重大合法权益担忧很难得到您同意的；<br />
<br />
（6）响应您的请求将导致其他个人信息主体或其他个人、组织的合法权益受到严重损害的；<br />
<br />
（7）涉及商业秘密的。<br />
<br />
4、我们可能分享、转让、公开披露您的个人信息<br />
<br />
4.1未经您同意，我们不会将您带有个人标识或身份识别的信息分享给任何第三方，但如下情况除外：<br />
<br />
4.1.1征得您的同意；<br />
<br />
在征得您的同意后，我们仅会出于合法、正当、必要、特定、明确的目的与其他公司、组织和个人分享您的个人信息。我们必须您选择同意才会共享任何您的个人信息。<br />
<br />
4.1.2出于法律的原因<br />
<br />
我们还可能为以下需要而保留、保存或披露您的个人信息：<br />
<br />
（1）遵守适用的法律法规；<br />
<br />
（2）遵守法院命令或其他法律程序的规定；<br />
<br />
（3）遵守相关政府机关的要求；<br />
<br />
（4）为遵守适用的法律法规、维护社会公共利益，或保护我们的客户、集团公司、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途。<br />
<br />
4.2 您同意，为实现更好的服务，我们可能将您的不带有个人标识或身份识别的个人信息与我们的关联公司、合作伙伴及第三方服务供应商、承包商及代理（例如代表我们发出电子邮件或通知的通讯服务提供商、为我们提供位置数据的地图服务供应商）分享（他们可能并非位于您所在的法域），用作下列用途：<br />
<br />
（1）向您提供我们的服务；<br />
<br />
（2）实现“我们可能如何使用信息”部分所述目的；<br />
<br />
（3）履行我们在本《隐私政策》中的义务和行使我们的权利；<br />
<br />
（4）理解、维护和改善我们的服务。<br />
<br />
如我们与任何上述第三方分享您的个人信息，我们将会采用加密、匿名化、去标识化等手段保障您的信息安全和个人隐私，同时将努力确保该等第三方在使用您的个人信息时遵守本《隐私政策》及我们要求其遵守的其他适当的保密和安全措施，以保障您的个人信息安全。<br />
<br />
我们的合作伙伴包括以下类型：<br />
<br />
（1）第三方服务供应商。我们可能会将您的个人信息共享给支持我们功能的第三方。这些支持包括为我们提供基础设施技术服务、支付服务、数据处理。我们共享这些信息的目的是可以实现我们提供游戏服务的基础功能。<br />
<br />
（2）纠纷处理。当您在使用App及相关服务的过程中，如与其他第三方发生纠纷、投诉或被投诉时，为了保护您与其他主体的合法权益，维护良好的交易秩序和社会环境，我们会基于有关部门的要求将您的姓名、有效证件号码、联系方式、纠纷内容提供给消费者权益保护部门及监管机关，以便及时处理纠纷，但法律法规明确禁止提供的除外。<br />
<br />
4.3 转让：我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：<br />
<br />
4.3.1 事先获得您明确的同意或授权；<br />
<br />
4.3.2 根据适用的法律法规、法律程序的要求、强制性的行政或司法要求而必须进行提供；<br />
<br />
4.3.3 根据与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定而提供；<br />
<br />
4.3.4 在涉及我们收购、兼并、破产清算、重组等变更时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司或组织继续履行本《隐私政策》项下的责任和义务。如变更后的主体需变更个人信息使用目的，我们会要求其事先获得您的明示同意。<br />
<br />
4.4 公开披露：我们仅会在以下情况下，且在采取符合业界标准的安全防护措施的前提下，才会公开披露您的个人信息：<br />
<br />
4.4.1 根据您的需求，在您明确同意的披露方式下披露您所指定的个人信息；<br />
<br />
4.4.2 根据法律、法规的要求、行政或司法机关的强制性要求，我们可能会公开披露您的个人信息。当我们收到上述披露请求时，我们会依法要求请求方出具相关法律文件，如传票或调查函等。我们会慎重审查每一披露请求，以确保该等披露请求符合相关法律规定。在法律法规许可的前提下，我们会对包含披露信息的文件进行加密保护。<br />
<br />
5、信息安全<br />
<br />
5.1我们仅在本《隐私政策》所述目的所必需的期间内和法律法规要求的条件下存储您的个人信息。<br />
<br />
5.2我们努力为您提供信息保护，以免保存的信息在未经授权的情况下被访问、篡改、披露或破坏。为此，我们可能采取以下措施：<br />
<br />
5.2.1我们使用加密技术对相关服务进行加密；<br />
<br />
5.2.2我们提供了多重验证供您在账户中使用，并在浏览器中提供了安全浏览功能；<br />
<br />
5.2.3我们会审查信息收集、存储和处理方面的做法（包括物理性安全措施），以避免遭到未经授权的访问；<br />
<br />
5.2.4我们只允许那些为了帮我们处理个人信息而需要知晓这些信息的员工、承包商和代理商访问个人信息，而且他们需要履行严格的合同保密义务，如果其未能履行这些义务，就可能会被追究法律责任或被终止其与我们的关系。<br />
<br />
5.2.5 我们收集的用户个人信息，除用于必要的身份验证外，将采取匿名化、去标识化处理，避免任何人（包括与我们合作的第三方）识别出个人身份，保障隐私安全。<br />
<br />
5.3但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。<br />
<br />
5.4 我们收集与您相关的个人信息，根据中国法律法规规定，仅会存储在中国境内服务器。未经您的另行同意及相关政府部门的审批，我们不会跨境传输或存储您的个人信息。如部分服务涉及跨境业务，我们需要向境外机构传输境内收集的相关个人信息的，我们会按照法律法规和相关监管部门的规定执行，向您说明个人信息出境的目的以及涉及的个人信息类型，征得您的同意，并通过签订协议、现场核查等有效措施，要求境外机构为所获得的您的个人信息保密。<br />
<br />
5.5 我们不会收集和存储您的生物识别信息，例如指纹、FaceID、虹膜识别信息等，除非基于政府机关、权力机关或相关法律法规或政策的强制要求（例如未成年人防沉迷政策），或经您的另行同意。即便基于上述要求，我们仅用于您的身份验证比对，我们不会对其留存。<br />
<br />
5.6 我们会通过安全的方式存储您的信息，包括本地存储（例如利用 APP 进行数据缓存）、数据库和服务器日志。<br />
<br />
5.7 一般情况下，我们只会在为实现服务目的所必需的时间内或法律法规规定的条件下存储您的个人信息。<br />
<br />
5.7.1 在用户使用我们产品及/或服务期间，我们会持续保存用户的个人信息。<br />
<br />
5.7.2 根据相关法规要求，我们将保存您的购买记录自您购买之日起180 天。对于其他数据的保存期限，我们承诺将是为了实现我们产品及/或服务目的所必需的最短期限。在超出上述期限后，我们会对您的相关信息进行删除或匿名化处理。<br />
<br />
<br />
6、您分享的信息<br />
<br />
6.1我们的服务，可让您与使用该服务的所有用户公开分享您的相关信息，例如，您在我们的服务中所上传或发布的信息（包括您公开的个人信息、您建立的名单、组队信息等）、您对其他人上传或发布的信息作出的回应，以及包括与这些信息有关的位置数据和日志信息。使用我们服务的其他用户也有可能分享与您有关的信息（包括位置数据和日志信息）。只要您不删除共享信息，有关信息会一直留存在公共领域；即使您删除共享信息，有关信息仍可能由其他用户或不受我们控制的非关联第三方独立地缓存、复制或储存，或由其他用户或该等第三方在公共领域保存。<br />
<br />
<br />
6.2请您谨慎考虑通过我们的服务上传、发布和交流的信息内容。在一些情况下，您可通过我们某些服务的隐私设定来控制有权浏览您共享信息的用户范围。如要求从我们的服务中删除您的相关信息，请通过该等特别服务条款提供的方式操作。<br />
<br />
<br />
7、Cookies、网络信标和相关技术<br />
<br />
7.1我们或我们的第三方合作伙伴，可能通过cookies、网络信标或其他相关技术收集和使用您的信息，并将该等信息储存为日志信息。我们使用自己的cookies和网络信标，目的是为您提供更好的用户体验和服务，并用于以下用途：<br />
<br />
7.1.1记住您的身份。cookies和网络信标有助于我们辨认您作为我们的用户的身份；<br />
<br />
7.1.2分析您使用我们服务的情况。<br />
<br />
7.1.3 广告优化。Cookies和网络信标有助于我们根据您的信息，向您提供更好的广告优化服务。<br />
<br />
7.2我们的产品和服务上可能会有广告商或其他合作方放置的cookies和网络信标。这些cookies和网络信标可能会收集与您相关的非个人身份信息，以用于分析用户如何使用该等服务或用于评估广告服务的效果。这些第三方cookies和网络信标收集和使用该等信息，不受本《隐私政策》约束，而是受相关使用者的隐私政策约束，我们不对第三方的cookies或网络信标承担责任。<br />
<br />
7.3 邮件<br />
<br />
您在使用我们的服务时，我们可能使用您的信息向您的设备发送电子邮件。如您不希望收到这些信息，可以按照我们的相关提示，在设备上选择取消订阅。<br />
<br />
7.4 与服务有关的公告<br />
<br />
我们可能在必要时（例如因系统维护而暂停某一项服务时）向您发出与服务有关的公告。<br />
<br />
<br />
8、未成年人保护<br />
<br />
我们非常重视对未成年人个人信息的保护。<br />
<br />
根据相关法律法规的规定，若您是18周岁以下的未成年人，在使用我们的服务前，应事先取得您的家长或法定监护人的同意。<br />
<br />
我们会采取严格加密措施存储未成年人信息，保障信息安全。对未成年信息的收集和使用，我们将会保持在法律允许和满足实际使用目的的最低限度。如您不再使用我们的服务，或我们提供的产品或服务停止运营时，您可以随时通知我们，或我们将主动删除未成年人的个人信息。<br />
<br />
如果我们无意、错误或意外地收集了未成年人的个人信息，我们将及时对其进行删除，除非法律法规要求我们保留此类资料。<br />
<br />
<br />
9、隐私政策的适用范围<br />
<br />
<br />
我们提供的所有服务均会适用本隐私政策。<br />
<br />
<br />
请您注意，本《隐私政策》不适用于以下情况：<br />
<br />
<br />
（1）通过我们的服务而接入/跳转的第三方服务（包括任何第三方网站），而由该第三方收集的信息；<br />
<br />
<br />
（2）通过在我们服务中进行广告服务的其他公司或机构所收集的信息。<br />
<br />
<br />
您在使用第三方服务须受该第三方隐私政策（非本文所示之隐私政策）约束，需要您仔细阅读其政策内容。<br />
<br />
<br />
10、本政策如何更新<br />
<br />
<br />
我们的隐私政策可能变更。<br />
<br />
<br />
未经您明确同意，我们不会削减您依据当前生效的本政策所应享受的权利。当本政策发生重大变化时，我们将采取弹窗提醒、消息发送、邮件通知或官方网站发布公告等方式及时通知您，构成重大变化的情况包括但不限于：<br />
<br />
<br />
1.我们提供的服务范围、模式等发生重大变化，如收集、使用个人信息的目的、处理个人信息的类型、个人信息的使用方式、接收数据的第三方身份等发生改变；<br />
<br />
2.我们的经营主体、组织架构、所有权结构等方面发生重大变化，如业务调整、兼并收购重组等引起的所有者变更；<br />
<br />
3.您参与个人信息处理方面的权利及其行使方式发生重大变化；<br />
<br />
4.个人信息共享、转让或公开披露的方式、主要对象等发生变化；<br />
<br />
5.其他可能对您的个人信息权益产生重大影响的变化。<br />
<br />
<br />
如您在本政策更新生效后继续使用App服务，即表示同意受经修订的本《隐私政策》的约束。<br />
<br />
<br />
11、联系我们<br />
<br />
<br />
如您对本《隐私政策》或其他相关事宜有疑问，欢迎通过拨打客服电话：0755-86700315联系我们。<br />
<br />
<br />
如您有任何个人信息的疑问、意见、建议或投诉举报，请通过以下联系方式与我们联系：<br />
<br />
电子邮箱：【kf@r2game.com】<br />
<br />
邮寄地址：深圳市南山区南海大道蛇口网谷万海大厦C座9楼，客服部（收）<br />
<br />
<br />
我们将在15个工作日内回复您。<br />
<br />
<br />
注：本《隐私政策》版本更新日期为2022年12月15日，如您认为更新的《隐私政策》对您更为有利，我们同意双方适用新的《隐私政策》内容。<br />
<br />
本版本《隐私政策》更新内容主要如下：<br />
<br />
1、增加了支付宝、广点通、今日头条、unity及穿山甲SDK收集的信息<br />
<br />
<br />
附件：<br />
<br />
第三方SDK提供或收集的信息<br />
<br />
<br />
SDK名称<br />
<br />
收集或分享的信息<br />
<br />
实现的功能和目的<br />
<br />
R2 SDK<br />
<br />
（1）idfa（仅iOS）<br />
<br />
（2）机型<br />
<br />
（3）操作系统型号<br />
<br />
（4）系统语音<br />
<br />
（5）地区<br />
<br />
（6）设备名称<br />
<br />
（7）android id<br />
  （8）设备信息: IMEI、Android ID、OAID、mac地址<br />
<br />
（1）用于判断用户的手机类型，分别走不同的厂商渠道。<br />
<br />
（2）用于判断用户的手机操作系统型号，以适应软件开发。<br />
<br />
（3）支持根据不同语言显示不同的语言内容。<br />
<br />
（4）支持对不同地区进行用户服务。<br />
<br />
（5）用于用户设备的唯一标识<br />
<br />
微信SDK<br />
<br />
网络状态、设备信息，包括：IMEI、IMSI、Android ID、UAID、OAID、mac地址、应用安装列表；网络状态；联网方式；手机号码；微信账号<br />
  参考隐私协议：[链接]<br />
<br />
实现微信账号登录游戏，微信支付（Android），分享<br />
<br />
QQSDK<br />
<br />
网络状态、设备信息，包括：IMEI、IMSI、Android ID、UAID、OAID、mac地址、应用安装列表；网络状态；联网方式；<br />
  参考隐私协议：[链接]<br />
<br />
实现QQ账号登录游戏，分享<br />
<br />
支付宝 SDK<br />
<br />
网络状态、设备信息，包括：IMEI、IMSI、Android ID、UAID、OAID、mac地址、应用安装列表、传感器、ICCID、设备序列号、BSSID、IP地址；网络状态；联网方式；手机号码；支付宝账号<br />
  参考隐私协议：[链接]<br />
<br />
实现支付宝支付（Android）<br />
<br />
4399 SDK<br />
<br />
不收集信息<br />
  参考隐私政策： [链接]<br />
<br />
第三方登录、支付及实名制服务<br />
<br />
华为HMSSDK<br />
<br />
网络状态、设备信息，包括：IMEI、Android ID、mac地址、位置信息、应用安装列表；<br />
  参考华为开发者联盟与隐私的声明：[链接]<br />
<br />
第三方登录、支付及实名制服务<br />
<br />
aihelp SDK<br />
<br />
身份信息及日志数据，参考隐私政策：[链接]<br />
<br />
处理用户的查询并回复用户的请求<br />
<br />
appsflyer SDK<br />
<br />
身份信息及日志数据，参考隐私政策：[链接]<br />
<br />
处理用户的查询并回复用户的请求<br />
<br />
OPPO SDK<br />
<br />
网络状态、设备信息，包括：IMEI、Android ID、mac地址、位置信息、应用安装列表；读取和修改存储权限、读取手机状态和身份，参考隐私政策：[链接]<br />
<br />
第三方登录、支付及实名制服务<br />
<br />
VIVO SDK<br />
<br />
用vivo设备及服务过程中的操作系统版本号、应用程序信息、设备标识符、MAC地址、get_tasks、移动运营商、使用语言、系统设置、设备和应用程序数据。参考隐私政策：[链接]<br />
<br />
第三方登录、支付及实名制服务<br />
<br />
摸摸鱼<br />
<br />
位置信息、账号信息、身份信息、设备所在位置相关信息、日志信息、网络环境、应用安装列表；参考隐私政策: [链接]<br />
<br />
第三方登录、支付及实名制服务<br />
<br />
抖音直播联运（字节跳动联运<br />
<br />
位置信息、账号信息、身份信息、设备所在位置相关信息、日志信息、网络环境、应用安装列表；参考隐私政策: [链接]<br />
<br />
第三方登录、支付及实名制服务<br />
<br />
小米<br />
<br />
位置信息、账号信息、身份信息、设备所在位置相关信息、日志信息、网络环境、应用安装列表；参考隐私政策 :[链接]<br />
<br />
第三方登录、支付及实名制服务<br />
<br />
魅族<br />
<br />
位置信息、账号信息、身份信息、设备所在位置相关信息、日志信息、网络环境、应用安装列表；参考隐私政策: [链接]<br />
<br />
第三方登录、支付及实名制服务<br />
<br />
努比亚<br />
<br />
位置信息、账号信息、身份信息、设备所在位置相关信息、日志信息、网络环境、应用安装列表；参考隐私政策: [链接]<br />
<br />
第三方登录、支付及实名制服务<br />
<br />
MUMU模拟器<br />
<br />
位置信息、账号信息、身份信息、设备所在位置相关信息、日志信息、网络环境、应用安装列表；参考隐私政策: [链接]<br />
<br />
第三方登录、支付及实名制服务<br />
<br />
百度（多酷）<br />
<br />
位置信息、账号信息、身份信息、设备所在位置相关信息、日志信息、网络环境、应用安装列表；参考隐私政策: [链接]<br />
<br />
第三方登录、支付及实名制服务<br />
<br />
联想<br />
<br />
位置信息、账号信息、身份信息、设备所在位置相关信息、日志信息、网络环境、应用安装列表；参考隐私政策: [链接]<br />
<br />
第三方登录、支付及实名制服务<br />
<br />
HTC<br />
<br />
位置信息、账号信息、身份信息、设备所在位置相关信息、日志信息、网络环境、应用安装列表；参考隐私政策:[链接]<br />
<br />
第三方登录、支付及实名制服务<br />
<br />
黑鲨<br />
<br />
位置信息、账号信息、身份信息、设备所在位置相关信息、日志信息、网络环境、应用安装列表；参考隐私政策：[链接]<br />
<br />
第三方登录、支付及实名制服务<br />
<br />
bilibili<br />
<br />
位置信息、账号信息、身份信息、设备所在位置相关信息、日志信息、网络环境、应用安装列表；参考隐私政策：[链接]<br />
<br />
第三方登录、支付及实名制服务<br />
<br />
360<br />
<br />
位置信息、账号信息、身份信息、设备所在位置相关信息、日志信息、网络环境、应用安装列表；<br />
  参考隐私政策：[链接]<br />
<br />
第三方登录、支付及实名制服务<br />
<br />
金立<br />
<br />
位置信息、账号信息、身份信息、设备所在位置相关信息、日志信息、网络环境、应用安装列表；参考隐私政策：[链接]<br />
<br />
第三方登录、支付及实名制服务<br />
<br />
应用宝<br />
<br />
MAC地址、IDFA、网络状况、网络类型、应用安装列表；参考隐私政策：[链接]<br />
<br />
第三方登录、支付及实名制服务<br />
<br />
易盾 SDK<br />
<br />
软件列表；日志信息；设备信息，包括：MAC地址、IMEI、Android ID、IDFA、OpenUDID、GUID、SIM卡IMSI信息<br />
  参考隐私政策：[链接]<br />
<br />
检测是否修改游戏内存<br />
<br />
广点通SDK<br />
<br />
设备标识信息，包括：IMEI、Android id。传感器、应用列表、BSSID，相关链接: [链接]<br />
<br />
广告投放<br />
<br />
今日头条SDK<br />
<br />
设备标识信息，包括：IMEI、IMSI、BSSID、Mac地址、设备序列号、Android   id、IP地址、位置信息。相关链接：[链接]<br />
<br />
广告数据监测和投放<br />
<br />
数数科技SDK<br />
<br />
设备信息，包括：IMEI、IMSI、Android ID、UAID、OAID、mac地址、应用安装列表；网络状态信息；日志信息；IP地址，相关链接：[链接]<br />
<br />
用户行为分析<br />
<br />
快手SDK<br />
<br />
设备信息，包括：IMEI、IMSI、Android ID、UAID、OAID、mac地址、应用安装列表；参考隐私政策：[链接]<br />
<br />
广告数据监测和投放<br />
<br />
unity服务<br />
<br />
设备信息，包括：IMEI、Android ID、Mac地址、传感器、BSSID；IP，应用列表，参考隐私政策：[链接]<br />
<br />
提供账号登录、提报线上bug报错服务<br />
<br />
穿山甲<br />
<br />
设备信息，包括：IMEI、IMSI、Android ID、UAID、OAID、mac地址、BSSID、位置信息；地理位置信息，参考隐私政策：[链接]<br />
<br />
广告投放及广告监测归因、反作弊、减少app崩溃提供稳定可靠的服务<br />
<br />
即验SDK（联通一键登录）<br />
<br />
网络类型；屏幕尺寸；IP地址；手机号码，参考隐私政策：[链接]<br />
<br />
联通手机号码一键登录游戏功能，<br />
<br />
即验SDK（移动一键登录）<br />
<br />
网络身份标识；设备信息，包括：IMEI、IMSI、Android ID、UAID、OAID、mac地址参考隐私政策：[链接]<br />
<br />
移动手机号码一键登录游戏功能<br />
<br />
即验SDK（电信一键登录）<br />
<br />
IP地址；网络类型；设备信息，包括：IMEI、IMSI、Android ID、UAID、OAID、mac地址，参考隐私政策：[链接]<br />
<br />
电信手机号码一键登录游戏功能
    </div>
</template>

<script>


export default {
    name: 'Policy',
    data() {
        return {
            
        };
    },
    
    methods: {
        
    },
    mounted() {
        
    },
};
</script>
<style scoped>

.policy {
    overflow-y: scroll;
}
.policy::-webkit-scrollbar {
      width: 0.1rem;
  }

  .policy::-webkit-scrollbar-thumb {
      background-color: #a18f84;
  }
.van-popup {
  background-color: transparent;
}
  </style>
